import { useEffect } from 'react'
import { loadUsetifulScript, setUsetifulTags } from 'usetiful-sdk'
import { useAuth } from '../hooks/use-auth'

const USETIFUL_TOKEN = '911cd7d186bbae585241d9cf166c23c5'
let scriptLoaded = false

/**
 * Loads Usetiful once and updates user tags when the authenticated user changes.
 */
const UsetifulProvider = () => {
  const { user } = useAuth()

  // Load script once
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (scriptLoaded) return
    try {
      loadUsetifulScript(USETIFUL_TOKEN)
      scriptLoaded = true
    } catch (e) {
      // Non-fatal
      console.warn('Failed to load Usetiful script', e)
    }
  }, [])

  // Identify / tag user
  useEffect(() => {
    if (!user?.id) return
    try {
      let firstName = 'User'
      let lastName = user.id.slice(0, 6)
      if (user.name && user.name.trim().length > 0) {
        const parts = user.name.trim().split(/\s+/)
        firstName = parts[0]
        lastName = parts.slice(1).join(' ') || lastName
      } else if (user.email) {
        firstName = user.email.split('@')[0]
      }

      setUsetifulTags({
        userId: user.id,
        firstName,
        lastName,
        plan: user.plan,
        email: user.email,
        onboardingCompleted: user.onboardingCompleted,
      })
    } catch (e) {
      console.warn('Failed to set Usetiful tags', e)
    }
  }, [user])

  return null
}

export default UsetifulProvider
